import React from 'react';

import { logger } from '@/lib/logger';
import { getGlobals } from '@/lib/globals';
import { once } from '@/lib/utils';
import { HiddenInput } from './StyledComponents';

const onHiddenFieldChange = once(() => {
  const { browserName, deviceType } = getGlobals().device;

  logger.fpti('browser_auto_complete', {
    browser_type: browserName,
    device_channel: deviceType,
    state_name: 'browser_auto_complete',
    transition_name: 'process_browser_auto_complete',
  });
});

export const LogBrowserAutoComplete = (): JSX.Element => (
  <HiddenInput
    autoComplete="name"
    data-testid="log-browser-autocomplete"
    id="full-name"
    name="name"
    onChange={onHiddenFieldChange}
    // @ts-expect-error should be number
    // Avoiding altering prod code in TS conversion PR
    tabIndex="-1"
    type="text"
    aria-hidden="true"
  />
);
